import { useRef } from 'react'
import { Pressable, Text, View } from 'react-native'
import { useRouter } from 'expo-router'
import { useTranslation } from 'react-i18next'
import { SheetManager, type SheetProps } from 'react-native-actions-sheet'

import { cn } from '@/utils/cn'

import { BottomSheet } from './BottomSheet'

const PAYMENT_METHODS = ['bank', 'alipay', 'wechat', 'ermb', 'qq']

export function AddPaymentMethodSheet(props: SheetProps<'add-payment-method'>) {
  const router = useRouter()
  const { t } = useTranslation()
  const selected = useRef(false)
  function handlePress(kind: string) {
    selected.current = true
    SheetManager.hide(props.sheetId)
    if (props.payload?.onClose) {
      props.payload.onClose()
      setTimeout(() => {
        router.push({ pathname: '/(main)/setting/payment-method/add', params: { kind } })
      }, 200)
    } else {
      router.push({ pathname: '/(main)/setting/payment-method/add', params: { kind } })
    }
  }
  return (
    <BottomSheet
      closeDrawer={() => {
        const didSelect = selected.current
        selected.current = false
        if (!didSelect) props.payload?.onCancel?.()
      }}
    >
      {PAYMENT_METHODS.map((method) => (
        <Pressable onPress={() => handlePress(method)} key={method}>
          {({ pressed }) => (
            <View className={cn('flex-row justify-between px-4 py-3', pressed && 'bg-background-secondary')}>
              <Text className={'text-base text-text-primary'}>{t(`payment:${method}`)}</Text>
            </View>
          )}
        </Pressable>
      ))}
      <Pressable onPress={() => SheetManager.hide(props.sheetId)}>
        {({ pressed }) => (
          <View className={cn('flex-row justify-between px-4 py-3', pressed && 'bg-background-secondary')}>
            <Text className={'text-base text-text-primary'}>{t(`profile:cancel`)}</Text>
          </View>
        )}
      </Pressable>
    </BottomSheet>
  )
}
